/**
 * Deterministic people-avatar fallback using DiceBear's "micah" style, matching
 * the Storybook "Final" reference (`dashboard/final/_conversations.tsx`). Served
 * as an SVG from the DiceBear HTTP API — no bundled dependency. Use as the image
 * src wherever a real uploaded photo is absent; the `AvatarFallback` initials
 * still act as the last resort if the request fails.
 */
export function dicebearMicah(seed: string): string {
  return `https://api.dicebear.com/9.x/micah/svg?seed=${encodeURIComponent(seed)}`;
}
